import ApiBase from '../../ApiBase';

class Question extends ApiBase {
    route = '/admin/main-stage/sessions/:session/questions';
}

export default new Question();
